import { render, staticRenderFns } from "./mailling-title.vue?vue&type=template&id=5c46b48e&scoped=true"
import script from "./mailling-title.vue?vue&type=script&lang=js"
export * from "./mailling-title.vue?vue&type=script&lang=js"
import style0 from "./mailling-title.vue?vue&type=style&index=0&id=5c46b48e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46b48e",
  null
  
)

export default component.exports